import React, { useMemo } from 'react';
import { useEditNote } from '../../../../../../hooks/api/useNotes';
import { AnimateLoadedContent } from '../../../../../v2BaseComponents/Loader';
import NotesEditor from '../../../../../shared/Notes/NotesEditor';
import { NoteDestination, noteDetailsToDestination } from '../../../../../shared/Notes/utils/types';

export type NoteEditSideDrawerContentOwnProps = {
    onClose: (force: boolean) => void;
    noteId: string;
};

export type NoteEditSideDrawerContentProps = NoteEditSideDrawerContentOwnProps;

const NoteEditSideDrawerContent: React.FC<NoteEditSideDrawerContentProps> = ({ onClose, noteId }) => {
    const { isLoading, note, noteEditorProps, key } = useEditNote({
        noteId: noteId,
        onNoteLoadFailure: () => {
            onClose(false);
        },
    });

    const noteDestination = useMemo<NoteDestination | null>(
        () => (note ? noteDetailsToDestination(note) : null),
        [note],
    );

    return (
        <AnimateLoadedContent isLoading={isLoading || !note}>
            {() =>
                note ? (
                    <NotesEditor
                        key={key}
                        source="resources.notes-tab.edit-drawer"
                        onCancel={() => onClose(true)}
                        note={note}
                        noteDestination={noteDestination!}
                        {...noteEditorProps}
                    />
                ) : null
            }
        </AnimateLoadedContent>
    );
};

export default React.memo(NoteEditSideDrawerContent);
